import clsx from "clsx";

const Card = ({
  name,
  variant = "default",
  children,
  className,
  scroll = true,
  ...props
}) => {
  const variants = {
    default:
      "p-4 text-xl bg-[#0B1120] text-white",
    secondary: "p-6 pb-3 text-lg text-[#0B1120]",
  };

  return (
    <div
      className={clsx(
        "text-sm bg-white rounded-2xl shadow-2xl shadow-blue-900/5 border border-gray-100 flex flex-col",
        variant === "default" && "overflow-hidden",
        className
      )}
      {...props}
    >
      {name && (
        <div className={clsx(variants[variant])}>
          <h2 className="font-semibold tracking-tight">{name}</h2>
        </div>
      )}
      <div
        className={clsx(
          scroll && "overflow-y-auto",
          variant === "secondary" ? "p-6 pt-3" : "p-4"
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default Card;
